import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'
import cloneDeep from 'lodash/cloneDeep'

const KEYS = {
  SetItems: 'set_items',
  Clear: 'clear'
}

export const state = {
  autoAccounts: [],
  types: [],
  autoFloatingCenters: []
}
export const mutations = {
  [KEYS.SetItems](state, data) {
    if (data && data.autoAccounts && Array.isArray(data.autoAccounts)) {
      state.autoAccounts = data.autoAccounts
    } else {
      state.autoAccounts = []
    }

    if (data && data.autoFloatingCenters && Array.isArray(data.autoFloatingCenters)) {
      state.autoFloatingCenters = data.autoFloatingCenters
    } else {
      state.autoFloatingCenters = []
    }
  },

  [KEYS.Clear](state) {
    state.autoAccounts = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state, rootGetters }, options) {
    options = _.extend({ force: false }, options)

    var key = 'auto.accounts'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })

      const autoAccounts = cached.autoAccounts.map((autoAccount) => {

        if (autoAccount.hasChild) {
          autoAccount.selectableAccounts = rootGetters['accounts/children'](autoAccount.id, false).filter(account => !account.hasChild)
        }

        return autoAccount
      })

      cached.autoAccounts = autoAccounts

      if (cached != null) {
        commit(KEYS.SetItems, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('accounts.auto.listOfMine'), null)
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        autoAccounts: result.data.items,
        autoFloatingCenters: result.data.autoFloatingCenters
      }

      const autoAccounts = cacheObj.autoAccounts.map((autoAccount) => {

        if (autoAccount.hasChild) {
          autoAccount.selectableAccounts = rootGetters['accounts/children'](autoAccount.id, false).filter(account => !account.hasChild)
        }

        return autoAccount
      })

      cacheObj.autoAccounts = autoAccounts

      dispatch('cache/set', cacheObj, { root: true })
      commit(KEYS.SetItems, cacheObj)
    }
  },

  set({ commit }, list) {
    commit(KEYS.SetItems, list)
  },

  clear({ commit }) {
    commit(KEYS.Clear)
  }
}
export const getters = {
  all: state => {
    return state.autoAccounts
  },
  getItemsByKey: (state, getters, rootState, rootGetters) => (key, includeSelectable = true) => {
    let items = state.autoAccounts.filter(item => item.autoAccountTypeKey === key && item.autoAccountUserId === rootGetters['appContext/getUser'].id)
    if (items.length === 0) {
      items = state.autoAccounts.filter(item => item.autoAccountTypeKey === key && !item.autoAccountUserId)
    }

    const selectableItems = []

    items.forEach((x) => {
      if (x.hasChild && includeSelectable) {
        x.selectableAccounts.forEach((acc) => {
          const originalAccount = rootGetters['accounts/getById'](acc.id)
          acc.balance = originalAccount?.balance
          acc.accountNature = originalAccount?.accountNature
          acc.totalCredit = originalAccount?.totalCredit
          acc.totalDebit = originalAccount?.totalDebit
          acc.maxCenterLevel = originalAccount?.maxCenterLevel
          selectableItems.push(acc)
        })
      }
      else {
        const originalAccount = rootGetters['accounts/getById'](x.id)
        x.balance = originalAccount?.balance
        x.accountNature = originalAccount?.accountNature
        x.totalCredit = originalAccount?.totalCredit
        x.totalDebit = originalAccount?.totalDebit
        x.maxCenterLevel = originalAccount?.maxCenterLevel
        selectableItems.push(x)
      }
    })

    return selectableItems
  },
  getFloatingCentersByAutoKey: (state, getters, rootState, rootGetters) => keys => {
    return state.autoFloatingCenters.filter(item => keys.indexOf(item.autoAccountType.key) > -1 && item.user.id === rootGetters['appContext/getUser'].id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
